export default __webpack_public_path__ + "41b5fcaedf630e0b33c5f4796f317f3b.wav";